import React from 'react';
import { useFetchOutageListQuery } from '../outage/service';
import { TimeUtil } from "../utils/time";
import { useNavigate } from "react-router-dom";
import SkeletonBox from './SkeletonBox';
import { Card, Icon } from 'antd';
import CardTitle from './CardTitle';
import OutageWorldMap from '../outage/OutageWorldMap';
import { Outage } from '../outage/types';
import { useFetchMonitorRegionsQuery } from '../trackedWebsites/service';

type Props = {
    websiteGuid: string;
    url: string;
};

export default function SiteOutage({ websiteGuid, url }: Props) {
    const navigate = useNavigate();

    const currentDate = TimeUtil.utcNow();
    const sevenDaysAgo = TimeUtil.subtractDays(currentDate, 7);

    const { data: outageList, isLoading: isLoadingOutages } = useFetchOutageListQuery({
        url,
        startDate: sevenDaysAgo.format('YYYY-MM-DDTHH:mm:ss'),
        endDate: currentDate.format('YYYY-MM-DDTHH:mm:ss'),
    });

    const { data: monitoringRegionsData } = useFetchMonitorRegionsQuery();

    const hasOutage = outageList?.outages.active && Object.keys(outageList.outages.active).length > 0;

    return (
        <div className="dashboard-site-outage-box">
            {isLoadingOutages && <SkeletonBox />}
            {!isLoadingOutages && (
                <Card
                    data-cy="site-outage-box"
                    title={
                        <CardTitle
                            title="Site outage"
                            description="Over the last 7 days"
                        />
                    }
                    extra={
                        <div
                            className="view-report-btn"
                            onClick={() => navigate(`/site-outage?w_guid=${websiteGuid}`)}
                        >
                            <span>View report</span>
                            <Icon type="right" />
                        </div>
                    }
                >
                    <div className="outage-map-container custom-scrollbar">
                        <OutageWorldMap
                            url={url}
                            outageContext={hasOutage ? (outageList.outages.active as Outage) : null}
                            monitoringRegions={monitoringRegionsData ? monitoringRegionsData.regions : {}}
                            isLoading={isLoadingOutages}
                            width={280}
                            height={128}
                            scale={100}
                        />
                    </div>
                </Card>
            )}
        </div>
    );
}
